import { createSlice } from "@reduxjs/toolkit";
import { RepresentativeImageResult } from "../../interfaces/RepresentativeImageObject";
import { resetAllState } from "./resetAllState";
import { addRepresentativeImage } from "../../services/thunks/RepresentativeImageThunk";

interface RepresentativeImageState {
  /** Images added this session, newest first. There's no "list all" backend
   *  endpoint yet (only add), so this isn't the full catalog — just a record
   *  of what's been added via the Admin panel since it was opened. */
  images: RepresentativeImageResult[];
  loadingMap: Record<string, string | null>;
  errorMap: Record<string, string | null>;
  successMap: Record<string, boolean>;
}

const initialState: RepresentativeImageState = {
  images: [],
  loadingMap: {},
  errorMap: {},
  successMap: {},
};

const representativeImageSlice = createSlice({
  name: "representativeImages",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addRepresentativeImage.pending, (state) => {
        state.loadingMap.addRepresentativeImage = "Adding image...";
        state.errorMap.addRepresentativeImage = null;
        state.successMap.addRepresentativeImage = false;
      })
      .addCase(addRepresentativeImage.fulfilled, (state, action) => {
        state.loadingMap.addRepresentativeImage = null;
        state.successMap.addRepresentativeImage = true;
        state.images.unshift(action.payload);
      })
      .addCase(addRepresentativeImage.rejected, (state, action) => {
        state.loadingMap.addRepresentativeImage = null;
        state.errorMap.addRepresentativeImage = action.payload as string;
      });

    builder.addCase(resetAllState, () => initialState);
  },
});

export default representativeImageSlice.reducer;
